import { Product } from "@/types/product";
import { AppThunkAction } from "../types";
import { calculateCart } from "./async-thunk";
import { Discount, VoucherMeta } from "@/types/discount";
import { selectCartRequestBody } from "./selectors";
import { getDiscountId } from "@/helpers/discount";

export const addProduct = (productId: Product["id"]): AppThunkAction => {
  return (dispatch, getState) => {
    const lineItemsBody = selectCartRequestBody(getState());
    const productIndex = lineItemsBody.lineItems.products.findIndex(
      (p) => p.productId === productId
    );
    if (productIndex !== -1) {
      lineItemsBody.lineItems.products = lineItemsBody.lineItems.products.map((p) =>
        p.productId === productId ? { ...p, quantity: p.quantity + 1 } : p
      );
    } else {
      lineItemsBody.lineItems.products = [
        ...lineItemsBody.lineItems.products,
        {
          productId: productId,
          quantity: 1,
          type: "product",
        },
      ];
    }
    dispatch(calculateCart({ body: lineItemsBody }));
  };
};

export const removeProduct = (productId: Product["id"], quantity = 1): AppThunkAction => {
  return (dispatch, getState) => {
    const lineItemsBody = selectCartRequestBody(getState());
    const index = lineItemsBody.lineItems.products.findIndex((p) => p.productId === productId);
    const currentQuantity = lineItemsBody.lineItems.products[index].quantity;
    if (currentQuantity - quantity < 1) {
      lineItemsBody.lineItems.products = lineItemsBody.lineItems.products.filter(
        (p) => p.productId !== productId
      );
    } else {
      lineItemsBody.lineItems.products = lineItemsBody.lineItems.products.map((p) =>
        p.productId === productId ? { ...p, quantity: p.quantity - quantity } : p
      );
    }
    dispatch(calculateCart({ body: lineItemsBody }));
  };
};

export const removeDiscount = (
  voucherId: VoucherMeta["voucher"]["extId"],
  type: Discount["type"]
): AppThunkAction => {
  return (dispatch, getState) => {
    const lineItemsBody = selectCartRequestBody(getState());
    const newDiscounts = lineItemsBody.lineItems.discounts.filter(
      (d) => d.type === type && getDiscountId(d) !== voucherId
    );
    lineItemsBody.lineItems.discounts = newDiscounts;
    dispatch(calculateCart({ body: lineItemsBody }));
  };
};

export const addQrCode = (qrCode: string, expectAge = false): AppThunkAction => {
  return (dispatch, getState) => {
    const body = selectCartRequestBody(getState(), { qrCode });
    dispatch(calculateCart({ body, expectAge }));
  };
};

export const denyAgeCheck = (): AppThunkAction => {
  return (dispatch, getState) => {
    const body = selectCartRequestBody(getState(), { resetAgeCheck: true });
    dispatch(calculateCart({ body }));
  };
};

export const acceptAgecheck = (acceptedAge: number): AppThunkAction => {
  return (dispatch, getState) => {
    const body = selectCartRequestBody(getState(), { acceptedAge });
    dispatch(calculateCart({ body }));
  };
};
